import { Component, isDevMode, OnInit } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationStart, Router, ActivatedRoute } from '@angular/router';
import { AppInsightsService } from '@markpieszak/ng-application-insights';
import { filter, map } from 'rxjs/operators';

import { ConfigService } from '../services/config/config.service';
import { FlashMessagesService } from '../services/flash-messages/flash-messages.service';
import { SpinnerService } from '../services/spinner/spinner.service';
import { Title } from '@angular/platform-browser';
import { WindowService } from '../services/window/window.service';
import { AuthService } from '../services/auth/auth.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
    constructor(
        private flashMessagesService: FlashMessagesService,
        private router: Router,
        private spinnerService: SpinnerService,
        private ai: AppInsightsService,
        private config: ConfigService,
        private readonly activatedRoute: ActivatedRoute,
        private readonly title: Title,
        private windowService: WindowService,
        private authService: AuthService) {

        // Automatically start/stop spinner for navigation start + stop/cancel.
        router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
            if (isDevMode()) {
                console.log(`Routing to ${event.url}`);
            }
            this.spinnerService.start();
            this.flashMessagesService.clearAll();

            // Capture the shareable link URL and GUID from the URL and save it to local storage key returnUrl
            const shareableLinkPath = event.url;
            const guidRegExp = /[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/;
            if (shareableLinkPath.includes('video-request') && guidRegExp.test(shareableLinkPath)) {
              const matches = shareableLinkPath.match(guidRegExp);
              if (matches && matches.length > 0) {
                let guid: string | null = null;
                guid = matches[0];
                this.windowService.localStorage.setItem('returnUrl', window.location.origin + shareableLinkPath);
              }
            }

            } else if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
            this.spinnerService.stop();
            }
        });

        router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            map(() => {
                let child = this.activatedRoute.firstChild;
                while (child) {
                    if (child.firstChild) {
                        child = child.firstChild;
                    } else if (child.snapshot.data && child.snapshot.data["title"]) {
                        return child.snapshot.data["title"] as string;
                    } else {
                        return null;
                    }
                }
                return null;
            })
        )
        .subscribe((pageTitle?: string) => {
            const configValue = this.config.config;
            const environmentValue = (configValue.environment || "").trim().length > 0 ? ` (${configValue.environment})` : "";
            const pageTitleValue = (pageTitle || "").trim().length > 0 ? ` - ${pageTitle}` : "";
            this.title.setTitle(`${configValue.productName}${environmentValue}${pageTitleValue}`);
        });

        this.ai.config = {
            instrumentationKey: this.config.config.applicationInsightsInstrumentationKey
        };
        this.ai.init();
    }

    ngOnInit(): void {
        // --- RE-ADDED: Initialize MSAL from AppComponent ---
        if (this.authService) { // Check if authService exists
            if (isDevMode()) {
                console.log('Initializing MSAL from AppComponent');
            }
            // Call initMSAL - it has internal checks to prevent re-initialization
            this.authService.initMSAL();
        }
        // ----------------------------------------------------
    }
}
